import { useTranslate } from "@tolgee/react";

export function LearnHero() {
	const { t } = useTranslate();

	return (
		<div className="mb-6">
			<h1 className="text-title1 text-foreground">
				{t("learn.title")}
			</h1>
			<p className="mt-1 text-body2 text-muted-foreground">
				{t("learn.subtitle")}
			</p>
		</div>
	);
}
